<template>
  <div class="detail">
    <div class="banner">
      <img src="../../../assets/goin/news/banner.png" alt="">
    </div>
    <div class="detail-content">
      <div class="content">
        <div class="datail-date">{{info.create_time | getString(0,10)}}</div>
        <div class="datail-title">{{info.title}}</div>
        <div class="datail-desc">{{info.news_desc}}</div>
        <div class="html" v-html="html"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  newsInfo,
  getHtml
} from '@/api/news.js'
import Des from '@/util/des.js'

export default {
  data() {
    return {
      id: '',
      info: '',
      html: ''
    }
  },
  created() {
    this.id = this.$route.params.id
    this.newsInfo()
  },
  methods: {
    newsInfo() {
      const deskey = atob(localStorage.getItem('odeskey'))
      newsInfo({
        id: this.id
      })
      .then(res => {
        if (res.result === 1) {
          this.info = JSON.parse(Des.decryptByDES(res.data, deskey))
          this.gethtml(this.info.news_content)
        }
      })
    },
    gethtml(url) {
      getHtml(url)
      .then(res => {
        this.html = res
      })
    }
  },
  filters:{
    getString: function(str,a,b) {
      return str.slice(a,b)
    }
  },
}
</script>

<style lang="less" scoped>

.detail{
  .banner {
    img {
      width: 100%;
      vertical-align: top;
      border: none;
    }
  }
  .content{
    width: 1440px;
    max-width: 1440px;
    margin: 0 auto;
    padding: 58px 0 60px;
    .datail-date{
      font-size: 24px;
      font-weight: 400;
      color: #555555;
      line-height: 40px;
      margin-bottom: 29px;
    }
    .datail-title{
      font-size: 30px;
      font-weight: 400;
      color: #4E8B46;
      line-height: 53px;
      margin-bottom: 28px;
    }
    .datail-desc{
      font-size: 24px;
      font-weight: 400;
      color: #595858;
      line-height: 36px;
      margin-bottom: 58px;
    }
    /deep/ .html{
      font-size: 20px;
       img {
        width: 100%;
      }
      p {
        margin: 0;
      }
    }
  }
}

</style>